import { ButtonTypes, EditorToolbarOptions } from './types';

export const plaintextToolbarButtons: ButtonTypes[] = ['undo', 'redo'];

// basic richtext buttons
export const defaultToolbarButtons: ButtonTypes[] = [
  'undo',
  'redo',
  'bold',
  'italic',
  'underline',
  'link',
  'bulletList',
  'orderedList',
  'specialCharacters',
];

export const inlineBylineToolbarButtons: EditorToolbarOptions = [
  'undo',
  'redo',
  'bold',
  'italic',
  'underline',
  'link',
  'specialCharacters',
];

export const breakPoints = {
  xs: 380,
  sm: 480,
  md: 650,
  lg: 850,
  xl: 1050,
} as const;

export const ARTICLE_MAIN_EDITOR_TOOLBAR_ID = 'article-main-editor-toolbar';
